import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.order-planning-configuration')
  .factory('$processTracking', ProcessTrackingFactory);

/* @ngInject */
function ProcessTrackingFactory($bringozFactory: $bringozFactory,
                               ProcessTrackingAPI: BringozApi) {

  function $processTracking(id?: string) {
    return $bringozFactory(id, ProcessTrackingAPI);
  }

  return $processTracking;
}
